import clsx from 'clsx';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import TileCard from '@/src/components/common/Elements/Card/TileCard/TileCard';

const Default = (props) => {
  const [openList, setOpenList] = useState(false);
  const loggedUser = useSelector((state) => state.loggedUser);
  const dispatch = useDispatch();

  const component = props.component ? props.component({ type: props.type }) : null;

  const handleOpen = () => {
    setOpenList(true);
  };

  const handleClose = () => {
    setOpenList(false);
  };

  const handleRedirect = () => {
    if (props.type !== 'files') {
      dispatch({ type: 'SET_TASKS_COUNTER', counter: props.type });

      if (loggedUser.data.userRole > 3 && loggedUser.data.userRole !== 5) {
        dispatch({
          type: 'UPDATE_PROCESSES_SELECTED_CATEGORY',
          selected: { value: 'mytasks', label: 'My Tasks' },
        });
      }

      window.location.replace(`/account#/projects/${props.projectId}/processes`);
    } else {
      window.location.replace(`/account#/projects/${props.projectId}/inbox`);
    }
  };

  return (
    <React.Fragment>
      <TileCard
        className={clsx('counterElements', props.type, props.classes, openList && 'active:')}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
      >
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <a onClick={handleRedirect} role="button" tabIndex="0">
          <div className={`counterContainer ${props.classes} ${openList ? 'active' : ''}`}>
            <div className="titleIconContainer">
              <div className="iconContainer">{props.icon.default}</div>
              {props.title.default && (
                <div className="titleContainer">
                  <p>{props.title.default}</p>
                  <p className={`additionalStats ${props.delay > 0 ? 'delayed' : ''}`}>{`${
                    props.delay > 0 ? `${props.delay} Delayed Task` : ''
                  } ${
                    props.change_requested > 0 ? `${props.change_requested} Change Requested` : ''
                  }`}</p>
                </div>
              )}
            </div>
            <div className="countContainer">
              <div className="countValue">
                <span>{props.count}</span>
              </div>
            </div>
          </div>
        </a>
        {openList && component}
      </TileCard>
    </React.Fragment>
  );
};

Default.defaultProps = {
  icon: {
    default: <i className="material-icons">description</i>,
    active: <i className="material-icons">description</i>,
  },
  title: {
    default: '',
    layout1: '',
  },
  additionalStatus: '',
  count: 0,
  classes: '',
};

export default Default;
